export default __webpack_public_path__ + "static/media/money_shower_450.636df082.jpg";